import React, { useState, useContext } from "react";

import {
  Divider,
  Grid,
  CardActions,
  CardContent,
  Card,
  CardHeader,
  Button,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { AppStateContext } from "../Contexts/AppStateContext";
import ChangePasswordForm from "./ChangePasswordForm";
import { UserDataContext } from "../Contexts/UserDataContext";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  block: {
    marginTop: theme.spacing(4),
  },
  field: {
    padding: theme.spacing(2),
  },
  action: {
    padding: theme.spacing(2),
  },
  message: {
    padding: theme.spacing(2),
    color: theme.palette.error.main,
    paddingBottom: 0,
  },
}));

const SettingsPage = () => {
  const classes = useStyles();
  const { userData, setUserData } = useContext(UserDataContext);

  // Local state.
  const [freq, setFreq] = useState({
    daily: userData.enableDaily,
    weekly: userData.enableWeekly,
  });
  const [showError, setShowError] = useState(
    !(userData.enableDaily || userData.enableWeekly)
  );

  const call = async (type, checked) => {
    try {
      await axios({
        method: "POST",
        url: `/users/${type}/${checked}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userData.token}`,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const callAll = async (calls) => {
    for (let i = 0; i < calls.length; i++) {
      await calls[i]();
    }
  };

  // Function which consolidates the logic between both updates.
  const updateFreq = (newFreq) => {
    // Update local state.
    setFreq(newFreq);

    // Validate selection.
    const canUpdate = newFreq.daily || newFreq.weekly;
    const error = !canUpdate;

    // Update whether the error message can be shown.
    if (error !== showError) {
      setShowError(error);
    }

    // Only if we can update should we push any data changes to the user data context.
    if (canUpdate) {
      // Backend update.
      const calls = [];
      if (newFreq.daily !== userData.enableDaily) {
        calls.push(() => call("setDaily", newFreq.daily));
      }
      if (newFreq.weekly !== userData.enableWeekly) {
        calls.push(() => call("setWeekly", newFreq.weekly));
      }

      // Make sure to push any deactivate request last, so as not to move through an invalid state.
      if (!newFreq.daily) {
        calls.reverse();
      }
      callAll(calls);

      // Frontend update.
      setUserData({
        ...userData,
        enableDaily: newFreq.daily,
        enableWeekly: newFreq.weekly,
      });
    }
  };

  const onChangeDaily = (event) => {
    const newFreq = {
      ...freq,
      daily: event.target.checked,
    };
    updateFreq(newFreq);
  };

  const onChangeWeekly = (event) => {
    const newFreq = {
      ...freq,
      weekly: event.target.checked,
    };
    updateFreq(newFreq);
  };

  return (
    <>
      <Grid container spacing={4}>
        {/* <Grid item sm={6} xs={12}>
          <Card className={classes.block}>
            <CardHeader title="Email Preferences"></CardHeader>

            <Divider />

            <CardContent>
              <Grid container>
                <Grid item md={6} sm={12} className={classes.field}>
                  <FormControlLabel
                    value="daily"
                    control={
                      <Checkbox checked={freq.daily} onChange={onChangeDaily} />
                    }
                    label="Daily"
                  />
                </Grid>
                <Grid item md={6} sm={12} className={classes.field}>
                  <FormControlLabel
                    value="weekly"
                    control={
                      <Checkbox
                        checked={freq.weekly}
                        onChange={onChangeWeekly}
                      />
                    }
                    label="Weekly"
                  />
                </Grid>
              </Grid>
              {showError && (
                <>
                  <Divider />
                  <Typography className={classes.message}>
                    Please select at least one email frequency.
                  </Typography>
                </>
              )}
            </CardContent>
          </Card>
        </Grid> */}

        <Grid item sm={6} xs={12}>
          {/* Change Password Card */}
          <ChangePasswordForm className={classes.block} />
        </Grid>
      </Grid>
    </>
  );
};

export default SettingsPage;
